import React from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '@prisjakt/ui-app-context';
import RatingSmiley from '@prisjakt/ui-rating/src/smiley-rating';

import { Rating } from '@prisjakt/ui-rating/src/types';
import formatNumber from 'src/globals/helpers/format-number';

import * as S from './styles';

type OwnProps = {
  featured: boolean;
  rating?: Rating;
  reviewCount: number;
  storeLink: string;
};

const StoreReviews = ({
  featured,
  rating,
  reviewCount,
  storeLink,
}: OwnProps) => {
  const { market, t } = useAppContext();

  return (
    <S.StoreReviews>
      {rating && (
        <>
          <RatingSmiley
            featured={featured}
            rating={rating}
            scoreVisibility="row"
          />
          <S.Separator>|</S.Separator>
        </>
      )}
      <S.StoreLink
        color="link"
        component={<Link to={storeLink} />}
        ariaLabel={t('reviews', 'rating.n-reviews', {
          n: reviewCount,
          count: formatNumber(reviewCount, market.code),
        })}
        data-test="StoreInfoLink"
      >
        {t('reviews', 'rating.n-reviews', {
          n: reviewCount,
          count: formatNumber(reviewCount, market.code),
        })}
      </S.StoreLink>
    </S.StoreReviews>
  );
};

export default StoreReviews;
